import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_SETTINGS = {
  phone: "+39 347 129 0094",
  email: "giovannamatinointerior@gmail.com",
  address_line1: "Via Carmine Guadagno, 160",
  address_line2: "80038 Pomigliano d'Arco (NA)",
  instagram_url: "https://instagram.com/giovannamatinointerior",
  whatsapp_phone: "393471290094",
  whatsapp_message: "Ciao Giovanna, sto valutando un progetto di interior design/ristrutturazione e vorrei capire quale servizio è più adatto alle mie esigenze.",
  availability_slots: ["10:00", "11:00", "12:00", "15:00", "16:00", "17:00", "18:00"],
  availability_weekdays_off: [0],
  blocked_dates: [],
  min_notice_days: 1,
  max_advance_days: 60,
  opening_hours: "Lun–Sab · fino alle 19:00",
  service_areas: "Napoli, Campania e online",
  consultation_duration: "15 minuti",
  shop_visible: true,
  footer_short: "Studio di progettazione d'interni a Napoli, con consulenze anche online.",
  piva: "09203521217",
};

const SettingsContext = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const refreshSettings = () =>
    api.get("/settings")
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});

  useEffect(() => { refreshSettings(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export const telHref = (phone) => `tel:${(phone || "").replace(/[^+\d]/g, "")}`;
